import {
  FaShieldAlt,
  FaBolt,
  FaHeart,
  FaStar,
  FaSkull,
  FaArrowRight,
  FaCrosshairs,
  FaPlusCircle,
} from 'react-icons/fa';

const EmptyCircle = ({ size = 18, style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <circle cx="12" cy="12" r="10" />
  </svg>
);

const ABILITY_ICON_MAP = {
  Protect: FaShieldAlt,
  Shield: EmptyCircle,
  Blitz: FaBolt,
  Recover: FaHeart,
  Redeem: FaStar,
  Fell: FaSkull,
  Penetrate: FaArrowRight,
  Sniper: FaCrosshairs,
  MendWounds: FaPlusCircle,
  'Mend wounds': FaPlusCircle,
};

export function getAbilityFlyIconComponent(abilityName) {
  if (!abilityName) {
    return null;
  }
  return ABILITY_ICON_MAP[abilityName] || null;
}

export function abilityHasFlyIcon(abilityName) {
  return getAbilityFlyIconComponent(abilityName) != null;
}
